<template>
      <div class="col-md-12 page pdf">
        <div class="row file-upload-controls">
<!--
          <file-list :fileType="reportFileType" :fileList="reportList" @change="onReportSelected" :selectedItem="selectedReport" class="col-md-3 col-12"></file-list>
-->
          <span><a href="#reportDesc">Report descriptions</a></span>
        </div>
        <div class="void-filler-report" v-if="selectedReport === undefined">
          <h1 class="filler-header"><font-awesome-icon :icon="['fas', 'search-plus']" /></h1>
          <p>Select a report to view its contents or create a report from <router-link to="/pdfs">PDFs</router-link></p>
        </div>
        <report-content-body v-else :selectedReport="selectedReport" :key="selectedReport"/>
      </div>
</template>
<script>
  import router from '@/router/index';
  import { mapGetters } from 'vuex';
  import { REPORT_FILE_TYPE } from '@/config';
  import FileListDropdown from '@/components/includes/file/FileListDropdown';
  import ReportContentBody from '@/components/includes/report/ReportContentBody';
  import { ReportsNavigation } from '@/store/modules/fsm/messages';


  export default {
    name: 'report-page',
    data () {
      return {
        reportFileType: REPORT_FILE_TYPE
      }
    },
    methods: {
      onReportSelected(selectedReport) {
        router.push({
          name: ReportsNavigation,
          params: {
            selectedReport
          }
        });
      }
    },
    props: {
      selectedReport: {
        type: Number,
        required: false,
      },
    },
    components: {
      'file-list': FileListDropdown,
      'report-content-body': ReportContentBody
    },
    computed: {
      ...mapGetters('login/report', {
        reportList: 'getReportList'
      }),
    }
  }
</script>


<style scoped lang="scss">
    .page {
      padding-top: 1.0rem;
    }
    .void-filler-report {
      color: gray;
      font-size: 1.5rem;
      text-align: center;
      margin-top: 2.0rem;

      .filler-header {
        font-size: 2.5rem;
        text-align: center;
      }
    }
</style>
